import React from "react";

const Footer = () => (
  <footer className="bg-light text-dark pt-5">
    <div className="container">
      <div className="payment-methods text-center py-4">
        <h5 className="mb-3">Mode de paiement</h5>
        <div className="d-flex justify-content-center align-items-center flex-wrap">
          <img
            src="https://i.vimeocdn.com/video/1927593602-7385234439cae4a5452fec1d755591450b1afed012efb803cfe73a2464914cd1-d?f=webp"
            alt="PayPal"
            className="img-fluid mx-2"
            style={{ height: "30px" }}
          />
          <img
            src="https://www.reussir-mon-ecommerce.fr/wp-content/uploads/2016/03/logo-visa-carte-1.png"
            alt="Visa"
            className="img-fluid mx-2"
            style={{ height: "30px" }}
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
            alt="Mastercard"
            className="img-fluid mx-2"
            style={{ height: "30px" }}
          />
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdwjf1NKlfsjg1Ba36ZpwGyDEiIaq1iJ2bbw&s"
            alt="Maestro"
            className="img-fluid mx-2"
            style={{ height: "30px" }}
          />
          <img
            src="https://images.seeklogo.com/logo-png/48/2/apple-pay-acceptance-mark-logo-png_seeklogo-480102.png"
            alt="Apple Pay"
            className="img-fluid mx-2"
            style={{ height: "30px" }}
          />
          <img
            src="https://tse1.mm.bing.net/th/id/OIP.jsIxR8aATgDloXaFuFCgxgHaFj?cb=thfvnextfalcon2&rs=1&pid=ImgDetMain&o=7&rm=3"
            alt="Google Pay"
            className="img-fluid mx-2"
            style={{ height: "30px" }}
          />
        </div>

        {/* <div class="d-flex justify-content-center align-items-center">
                <i class="fab fa-cc-paypal fa-2x mx-2"></i>
                <i class="fab fa-cc-visa fa-2x mx-2"></i>
                <i class="fab fa-cc-mastercard fa-2x mx-2"></i>
                <i class="fab fa-cc-maestro fa-2x mx-2"></i>
                <i class="fab fa-cc-apple-pay fa-2x mx-2"></i>
                <i class="fa-brands fa-google-pay"></i>
                 </div> */}
      </div>

      <div className="row d-none d-sm-flex mt-3">
        {/* SERVICE CLIENT */}
        <div className="col-md-3 mb-4">
          <h6>SERVICE CLIENT</h6>
          <ul className="list-unstyled">
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://faq.recharge.fr/hc/fr"
              >
                FAQ
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/modes-de-paiement"
              >
                Mode de paiement
              </a>
            </li>
          </ul>
        </div>

        {/* CATEGORIES */}
        <div className="col-md-3 mb-4">
          <h6>CATEGORIES</h6>
          <ul className="list-unstyled">
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/credit-d-appel"
                target="_blank"
                rel="noopener noreferrer"
              >
                Recharger le crédit d'appel
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/entertaincards"
                target="_blank"
                rel="noopener noreferrer"
              >
                Carte Cadeau Musique, TV & Apps
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/carte-de-paiement-prepayee"
                target="_blank"
                rel="noopener noreferrer"
              >
                Carte de paiement
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/gamecards"
                target="_blank"
                rel="noopener noreferrer"
              >
                Carte prépayée jeux vidéo
              </a>
            </li>
          </ul>
        </div>

        {/* A PROPOS DE NOUS */}
        <div className="col-md-3 mb-4">
          <h6>À PROPOS DE NOUS</h6>
          <ul className="list-unstyled">
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://company.recharge.com/?utm_source=footer&utm_medium=consumersite-rchfr"
              >
                Notre Entreprise
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.com/fr/fr/business"
              >
                Pour le Business
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/conditions"
              >
                Conditions
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/politique-de-confidentialite"
              >
                Politique de Confidentialité
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/declaration-cookie"
              >
                Déclaration Cookie
              </a>
            </li>
          </ul>
        </div>

        {/* PRODUITS POPULAIRES */}
        <div className="col-md-3 mb-4">
          <h6>PRODUITS POPULAIRES</h6>
          <ul className="list-unstyled ">
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/carte-pcs"
              >
                Recharge PCS
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/carte-transcash"
              >
                Recharge Transcash
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/cashlib"
              >
                Recharge Cashlib
              </a>
            </li>
            <li>
              <a
                className="btn btn-link text-decoration-none p-0"
                href="https://www.recharge.fr/sfr"
              >
                Recharge SFR
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center py-3">
        &copy; {new Date().getFullYear()} Recharge.fr. Tous droits réservés.
      </div>
    </div>
  </footer>
);

export default Footer;
